module.exports = __webpack_public_path__ + "static/media/trending_soon_hero_laptop.9404486c.png";